import { TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export interface StockSearchValue {
  materialName: string;
  materialNumber: string;
}

interface StockSearchProps {
  onSearch: (value: StockSearchValue) => void;
}

const StockSearch = (props: StockSearchProps) => {
  const { onSearch } = props;
  const { t } = useTranslation();
  const [materialName, setMaterialName] = useState("");
  const [materialNumber, setMaterialNumber] = useState("");
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      onSearch({ materialName, materialNumber });
    }, 300);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [materialName, materialNumber, onSearch]);

  return (
    <div className="search-container stock-search-container">
      <TextField
        fullWidth
        placeholder={t("search")}
        value={materialName}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          setMaterialName(event.target.value)
        }
        size="small"
        variant="outlined"
      />
    </div>
  );
};

export default StockSearch;
